import { USER_TYPES } from 'shared_DEPRECATED/types/User';

import { useUserContext } from 'features/user/context';
import { useUserMode } from 'features/user/hooks';
import { useCoachQuery } from 'features/user/hooks/query/useCoach';

export const useCoachId = () => {
  const userMode = useUserMode();
  const { user } = useUserContext();

  const { coach } = useCoachQuery({
    enabled: userMode === USER_TYPES.USER,
  });

  return userMode === USER_TYPES.USER ? coach?.userId : user.userId;
};
